import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';
import { Road } from '../../modules/select-road/models/select-road.model';
import { StorageService } from './storage.service';
import { AVAILABLE_ROADS_KEY, SELECTED_ROAD_KEY } from '../../shared/constants/storage-keys';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  private selectedRoadSubject = new BehaviorSubject<Road | null>(
    this.storageService.getFromSessionStorage(SELECTED_ROAD_KEY),
  );
  private userRolesSubject = new BehaviorSubject<string[]>([]);
  private availableRoadsSubject = new BehaviorSubject<Road[]>(
    this.storageService.getFromSessionStorage(AVAILABLE_ROADS_KEY) || [],
  );
  private readonly refreshCenterActivitySubject = new Subject<void>();
  private readonly refreshRoadsSubject = new Subject<Road[]>();

  selectedRoad$: Observable<Road | null> = this.selectedRoadSubject.asObservable();
  userRoles$: Observable<string[]> = this.userRolesSubject.asObservable();
  availableRoads$: Observable<Road[]> = this.availableRoadsSubject.asObservable();
  readonly refreshCenterActivity$ = this.refreshCenterActivitySubject.asObservable();
  readonly refreshRoads$ = this.refreshRoadsSubject.asObservable();

  constructor(private storageService: StorageService) {}

  setSelectedRoad(road: Road | null): void {
    if (this.selectedRoadSubject.getValue() !== road) {
      this.selectedRoadSubject.next(road);
      this.storageService.saveToSessionStorage(SELECTED_ROAD_KEY, road);
    }
  }

  setUserRoles(roles: string[]): void {
    this.userRolesSubject.next(roles ?? []);
  }

  getUserRoles(): string[] {
    return this.userRolesSubject.getValue();
  }

  setAvailableRoads(roads: Road[]): void {
    this.availableRoadsSubject.next(roads);

    this.storageService.saveToSessionStorage(AVAILABLE_ROADS_KEY, roads);
  }

  getCurrentSelectedRoad(): Road | null {
    return this.selectedRoadSubject.getValue();
  }

  triggerCenterActivityRefresh(): void {
    this.refreshCenterActivitySubject.next();
  }

  triggerRoadsRefresh(roads: Road[]): void {
    this.refreshRoadsSubject.next(roads);
  }
}
